module.exports = __webpack_public_path__ + "img/arrow-90deg-right.b1e76c68.svg";